export enum ProductMode {
    REVENUE_OPTIMIZED = 'revenue_optimized',
    COST_OPTIMIZED = 'cost_optimized',
    BALANCED = 'balanced',
}
